import React, { useCallback } from 'react'
import { useModal } from '~/hooks'
import { Box } from '@material-ui/core'
import { mutualTheme } from '~/utils/theme'
import { CloudUploadIcon } from '~/assets/icons'
import { UploadPendenciesModal } from '~/components'
import { ServiceResponse } from '@mutual-libs/shared-types'
import { DocumentsGroup } from '@mutual-services/account-documents-types'
import { DocumentationActions, trackEvent } from '~/service/analytics'

export type PendenciesActionsProps = {
  isActive: boolean,
  updateDocuments: () => void,
  document: ServiceResponse<DocumentsGroup>,
  documents: ServiceResponse<DocumentsGroup[]>
}

const getIconColor = (isActive: boolean) => {
  return isActive ? mutualTheme.palette.secondary.main : mutualTheme.palette.textGray4.main
}

export const PendenciesActions: React.FC<PendenciesActionsProps> = (props) => {
  const { isActive, document, updateDocuments, documents } = props
  const [isOpen, toggleModal] = useModal()

  const openModal = useCallback(() => {
    trackEvent(DocumentationActions.SOLVE_PENDENCY)
    if (!isActive) {
      return
    }

    toggleModal()
  }, [toggleModal, isActive, trackEvent])

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <CloudUploadIcon sx={{ marginLeft: 1, cursor: isActive ? 'pointer' : 'default' }} onClick={openModal} htmlColor={getIconColor(isActive)} />
      <UploadPendenciesModal
        isVisible={isOpen}
        document={document}
        onClose={toggleModal}
        documents={documents}
        updateDocuments={updateDocuments}
      />
    </Box>
  )
}
